import { render, staticRenderFns } from "./CalculatorFieldPerShareholder.vue?vue&type=template&id=1d73fd0a&"
import script from "./CalculatorFieldPerShareholder.vue?vue&type=script&lang=ts&"
export * from "./CalculatorFieldPerShareholder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports